import { FILE_MANAGEMENT } from "./file-management.constants";

export const fetchFileList = (params: any) => {
  return {
    type: FILE_MANAGEMENT.FETCH_FILE_MANAGEMENT_LIST,
    payload: params,
  };
};

export const fetchUserDetails = (list: any) => {
  return {
    type: FILE_MANAGEMENT.FETCH_USER_DETAILS,
    payload: list,
  };
};

export const getAllFiles = (params: any) => {
  return {
    type: FILE_MANAGEMENT.GET_ALL_FILES,
    payload: params,
  };
};

export const getFileList = (list: any) => {
  return {
    type: FILE_MANAGEMENT.FILE_MANAGEMENT_LISTS,
    payload: list,
  };
};

export const createNewFolder = () => {
  return {
    type: FILE_MANAGEMENT.ADD_NEW_FOLDER,
  };
};

export const uploadFile = (
  formData: any,
  parentPath: string,
  fileName: string,
  resolve: ((value: unknown) => void) | undefined,
  reject: ((reason?: any) => void) | undefined
) => {
  return {
    type: FILE_MANAGEMENT.UPLOAD_FILE_MANAGEMENT,
    payload: { formData, parentPath, fileName },
    meta: { resolve, reject },
  };
};

export const deleteActionList = (data: any) => {
  return {
    type: FILE_MANAGEMENT.DELETE_FILE_MANAGEMENT_FOLDER,
    payload: data,
  };
};

export const getStorageConsumptionAction = (data: any) => {
  return {
    type: FILE_MANAGEMENT.GET_STORAGE_DATA,
    payload: data,
  };
};

export const storageDetails = (data: any) => {
  return {
    type: FILE_MANAGEMENT.GET_STORAGE_DETAILS,
    payload: data,
  };
};

export const downloadActionList = (data: any) => {
  return {
    type: FILE_MANAGEMENT.DOWNLOAD_LIST,
    payload: data,
  };
};

export const resetToOriginalState = () => {
  return {
    type: FILE_MANAGEMENT.RESET_TO_ORIGINAL_STATE,
  };
};

export const updateFileName = (index: number, value: string) => {
  return {
    type: FILE_MANAGEMENT.UPDATE_FILE_NAME,
    payload: { index, value },
  };
};

export const updateFolderName = () => {
  return {
    type: FILE_MANAGEMENT.UPDATE_FOLDER_NAME,
  };
};

export const checkAllCheckbox = (value: boolean) => {
  return {
    type: FILE_MANAGEMENT.CHECK_ALL_CHECKBOX,
    payload: value,
  };
};

export const checkSingleCheckbox = (id: number, value: boolean) => {
  return {
    type: FILE_MANAGEMENT.CHECK_SINGLE_CHECKBOX,
    payload: { id, value },
  };
};

export const sortingOrder = (direction: "asc" | "desc", key: string) => {
  return {
    type: FILE_MANAGEMENT.SORTING_ORDER,
    payload: { direction, key },
  };
};

export const searchText = (value: string) => {
  return {
    type: FILE_MANAGEMENT.SEARCH_VALUE,
    payload: value,
  };
};

export const searchServiceCall = (value: any) => {
  return {
    type: FILE_MANAGEMENT.SEARCH_FILTER,
    payload: value,
  };
};

export const searchFetchCall = (data: any) => {
  return {
    type: FILE_MANAGEMENT.SEARCH_FETCH_FILTER,
    payload: data,
  };
};

export const clearFilter = () => {
  return {
    type: FILE_MANAGEMENT.CLEAR_FILTER,
  };
};

export const calculatePercentage = (percentage: number, fileName: string, status: number) => {
  return {
    type: FILE_MANAGEMENT.UPLOAD_PERCENTAGE,
    payload: {
      percentage: percentage,
      fileName: fileName,
      status: status || 0
    },
  };
};

export const cancelUploadProgress = (data:any) => {
  return{
    type: FILE_MANAGEMENT.CANCEL_UPLOAD,
    payload: data
  };
}
